import React, { useState } from "react";
import axios from "axios";
import Orange from '../../assets/images/oranges.png';
import Airtel from '../../assets/images/airtel.png';
import Mpsa from '../../assets/images/mpsa.png';
import API_CONFIG2 from "../API_CONFIG2/API_CONFIG2";

const MobileMoneyForm = ({ id, prix, marque, modele, orangePhone, vodacomPhone, airtelPhone}) => {
  const [network, setNetwork] = useState("");
  const [phone, setPhone] = useState("");
  const [reservationCode, setReservationCode] = useState("");
  const [message, setMessage] = useState(null); // { type: 'success'|'error', text: '...' }
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false); // masquer le formulaire après succès

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (!network || !phone || !reservationCode) {
      setMessage({ type: "error", text: "Veuillez remplir tous les champs." });
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${API_CONFIG2.apiUrl}PaiementsFact.php`, {
        id,
        prix,
        network,
        phone,
        reservation_code: reservationCode,
      }, { timeout: 15000 });

      // Si l'API renvoie success = true (ex: 201)
      if (response.data && response.data.success) {
        // message venant du serveur (réel)
        const serverMsg = response.data.message || "Paiement enregistré avec succès.";
        // message final affiché à l'utilisateur après soumission
        const finalMsg = "Votre paiement a été soumis. Après vérification un email vous sera envoyé avec la facturation.";
        setMessage({ type: "success", text: `${serverMsg} — ${finalMsg}` });
        setSubmitted(true); // masque le formulaire et affiche le message final
        // clear fields (optionnel)
        setPhone("");
        setReservationCode("");
        setNetwork("");
      } else {
        // Cas où success=false mais 200 OK
        const errMsg = response.data?.message || "Erreur lors de l'enregistrement du paiement.";
        setMessage({ type: "error", text: errMsg });
      }
    } catch (err) {
      // Gérer erreurs HTTP (409 = conflict, 404, 500, etc.)
      if (err.response) {
        const status = err.response.status;
        const serverMsg = err.response.data?.message || 'Erreur serveur';
        if (status === 409) {
          setMessage({ type: "error", text: serverMsg || 'Paiement déjà enregistré pour ce code.' });
        } else if (status === 404) {
          setMessage({ type: "error", text: serverMsg || 'Code de réservation incorrect ou véhicule non lié à ce code.' });
        } else {
          setMessage({ type: "error", text: serverMsg || 'Erreur serveur, réessayez plus tard.' });
        }
      } else {
        // Pas de réponse (timeout, réseau)
        setMessage({ type: "error", text: "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez." });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const styles = {
    container: {
      maxWidth: "1200px",
      margin: "2rem auto",
      background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
      color: "#2d3748",
      padding: "3rem",
      borderRadius: "24px",
      boxShadow: `
        0 20px 40px rgba(255, 140, 0, 0.15),
        0 0 0 1px rgba(255, 140, 0, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.8)
      `,
      border: "1px solid rgba(255, 140, 0, 0.2)",
      animation: "formSlideIn 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      position: "relative",
      overflow: "hidden",
    },
    containerBefore: {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "4px",
      background: "linear-gradient(90deg, #FF8C00, #FFA500, #FFB732, #FFA500, #FF8C00)",
      animation: "shimmer 3s ease-in-out infinite",
    },
    title: {
      fontSize: "2.25rem",
      fontWeight: "800",
      marginBottom: "2rem",
      textAlign: "center",
      background: "linear-gradient(45deg, #FF8C00, #FFA500, #FF8C00)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      textShadow: "0 4px 15px rgba(255, 140, 0, 0.2)",
      animation: "titleGlow 2s ease-in-out infinite alternate",
      letterSpacing: "-0.5px",
    },
    infoBox: {
      background: "linear-gradient(135deg, rgba(255, 140, 0, 0.08) 0%, rgba(255, 255, 255, 0.6) 100%)",
      padding: "2rem",
      borderRadius: "16px",
      marginBottom: "2.5rem",
      border: "2px solid rgba(255, 140, 0, 0.15)",
      borderLeft: "6px solid #FF8C00",
      boxShadow: "0 8px 30px rgba(255, 140, 0, 0.12)",
      animation: "infoPulse 4s ease-in-out infinite",
      backdropFilter: "blur(10px)",
    },
    infoText: {
      fontSize: "1rem",
      lineHeight: "1.6",
      color: "#4a5568",
      textAlign: "center",
    },
    highlight: {
      color: "#FF8C00",
      fontWeight: "700",
      background: "linear-gradient(45deg, #FF8C00, #FFA500)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
    },
    networkList: {
      display: "flex",
      justifyContent: "center",
      gap: "2rem",
      marginTop: "1rem",
      flexWrap: "wrap",
    },
    networkItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "0.5rem",
      padding: "1rem",
      background: "rgba(255, 255, 255, 0.8)",
      borderRadius: "12px",
      border: "2px solid rgba(255, 140, 0, 0.1)",
      minWidth: "140px",
      transition: "all 0.3s ease",
    },
    networkItemHover: {
      transform: "translateY(-3px)",
      borderColor: "rgba(255, 140, 0, 0.3)",
      boxShadow: "0 8px 20px rgba(255, 140, 0, 0.15)",
    },
    networkIcon: {
      fontSize: "1.5rem",
      background: "linear-gradient(45deg, #FF8C00, #FFA500)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
    },
    networkName: {
      fontWeight: "600",
      color: "#FF8C00",
      fontSize: "0.9rem",
    },
    networkNumber: {
      fontWeight: "700",
      color: "#2d3748",
      fontSize: "0.85rem",
    },
    message: {
      marginBottom: "2rem",
      padding: "1.25rem 2rem",
      borderRadius: "12px",
      textAlign: "center",
      fontWeight: "600",
      fontSize: "1rem",
      animation: "messageSlideDown 0.4s ease-out",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "0.75rem",
      backdropFilter: "blur(10px)",
    },
    successMessage: {
      background: "linear-gradient(135deg, rgba(46, 204, 113, 0.1) 0%, rgba(255, 255, 255, 0.8) 100%)",
      border: "2px solid rgba(46, 204, 113, 0.3)",
      color: "#2d7742",
      borderLeft: "6px solid #2ecc71",
      boxShadow: "0 8px 25px rgba(46, 204, 113, 0.15)",
    },
    errorMessage: {
      background: "linear-gradient(135deg, rgba(231, 76, 60, 0.1) 0%, rgba(255, 255, 255, 0.8) 100%)",
      border: "2px solid rgba(231, 76, 60, 0.3)",
      color: "#c53030",
      borderLeft: "6px solid #e74c3c",
      boxShadow: "0 8px 25px rgba(231, 76, 60, 0.15)",
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: "2rem",
    },
    formRow: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "2rem",
    },
    formGroup: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
    label: {
      marginBottom: "0.75rem",
      fontWeight: "700",
      fontSize: "1rem",
      color: "#2d3748",
      display: "flex",
      alignItems: "center",
      gap: "0.75rem",
    },
    labelIcon: {
      fontSize: "1.25rem",
      background: "linear-gradient(45deg, #FF8C00, #FFA500)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
    },
    input: {
      padding: "1.125rem 1.5rem",
      background: "rgba(255, 255, 255, 0.9)",
      border: "2px solid #e2e8f0",
      borderRadius: "14px",
      color: "#2d3748",
      fontSize: "1rem",
      transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.05)",
      fontFamily: "inherit",
    },
    inputFocus: {
      borderColor: "#FF8C00",
      background: "rgba(255, 255, 255, 1)",
      boxShadow: `
        0 0 0 4px rgba(255, 140, 0, 0.15),
        0 8px 25px rgba(255, 140, 0, 0.2)
      `,
      transform: "translateY(-2px)",
    },
    select: {
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%23FF8C00' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 1.5rem center",
      backgroundSize: "18px",
      cursor: "pointer",
    },
    selectOption: {
      background: "white",
      color: "#2d3748",
      padding: "12px 16px",
      fontSize: "1rem",
    },
    button: {
      padding: "1.5rem 3rem",
      background: "linear-gradient(135deg, #FF8C00 0%, #FFA500 50%, #FF8C00 100%)",
      color: "white",
      border: "none",
      borderRadius: "16px",
      fontSize: "1.2rem",
      fontWeight: "800",
      cursor: "pointer",
      transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      position: "relative",
      overflow: "hidden",
      textTransform: "uppercase",
      letterSpacing: "1px",
      boxShadow: "0 12px 30px rgba(255, 140, 0, 0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "1rem",
      marginTop: "1rem",
      fontFamily: "inherit",
    },
    buttonHover: {
      transform: "translateY(-4px)",
      boxShadow: `
        0 20px 40px rgba(255, 140, 0, 0.5),
        0 0 0 1px rgba(255, 255, 255, 0.2)
      `,
      background: "linear-gradient(135deg, #FFA500 0%, #FFB732 50%, #FFA500 100%)",
    },
    buttonDisabled: {
      opacity: "0.7",
      cursor: "not-allowed",
      transform: "none",
      boxShadow: "0 6px 20px rgba(255, 140, 0, 0.3)",
    },
    spinner: {
      width: "22px",
      height: "22px",
      border: "3px solid transparent",
      borderTop: "3px solid white",
      borderRadius: "50%",
      animation: "spin 0.8s linear infinite",
    },
  };

  const [focusedField, setFocusedField] = useState(null);
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const [hoveredNetwork, setHoveredNetwork] = useState(null);

  const handleFocus = (field) => () => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField(null);
  };

  const networks = [
    { name: "Orange Money", number: orangePhone, icon: Orange },
    { name: "Airtel Money", number: airtelPhone, icon: Airtel },
    { name: "MPSA", number: vodacomPhone, icon: Mpsa }
  ];

  const keyframes = `
    @keyframes formSlideIn {
      0% {
        opacity: 0;
        transform: translateY(40px) scale(0.95);
      }
      100% {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
    
    @keyframes titleGlow {
      0% {
        text-shadow: 0 4px 15px rgba(255, 140, 0, 0.2);
      }
      100% {
        text-shadow: 0 4px 25px rgba(255, 140, 0, 0.4), 0 0 40px rgba(255, 140, 0, 0.3);
      }
    }
    
    @keyframes shimmer {
      0%, 100% { 
        background-position: -200% 0;
      }
      50% { 
        background-position: 200% 0;
      }
    }
    
    @keyframes infoPulse {
      0%, 100% { 
        box-shadow: 0 8px 30px rgba(255, 140, 0, 0.12);
        transform: scale(1);
      }
      50% { 
        box-shadow: 0 12px 40px rgba(255, 140, 0, 0.18);
        transform: scale(1.01);
      }
    }
    
    @keyframes messageSlideDown {
      0% {
        opacity: 0;
        transform: translateY(-20px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    @keyframes networkHover {
      0% {
        transform: translateY(0);
      }
      100% {
        transform: translateY(-3px);
      }
    }

    /* Styles pour les options du select */
    select option {
      background: white !important;
      color: #2d3748 !important;
      padding: 12px 16px !important;
      font-size: 1rem !important;
      border-bottom: 1px solid #e2e8f0 !important;
    }

    select option:hover {
      background: #FF8C00 !important;
      color: white !important;
    }

    select option:checked {
      background: linear-gradient(45deg, #FF8C00, #FFA500) !important;
      color: white !important;
    }

    /* Styles pour mobile */
    @media (max-width: 768px) {
      .mobile-money-container {
        padding: 2rem 1.5rem !important;
        margin: 1rem !important;
        border-radius: 20px !important;
      }
      
      .mobile-money-title {
        font-size: 1.75rem !important;
      }
      
      .mobile-money-info {
        padding: 1.5rem !important;
      }
      
      .form-row {
        grid-template-columns: 1fr !important;
        gap: 1.5rem !important;
      }
      
      .network-list {
        flex-direction: column !important;
        gap: 1rem !important;
      }
      
      .network-item {
        min-width: auto !important;
        width: 100% !important;
      }
    }
    
    @media (max-width: 480px) {
      .mobile-money-container {
        padding: 1.5rem 1rem !important;
        margin: 0.5rem !important;
      }
      
      .mobile-money-input {
        padding: 1rem 1.25rem !important;
        font-size: 16px !important;
      }
      
      .mobile-money-button {
        padding: 1.25rem 2rem !important;
        font-size: 1.1rem !important;
      }
      
      .mobile-money-title {
        font-size: 1.5rem !important;
      }
    }

    /* Empêcher le zoom sur iOS */
    @media screen and (max-width: 768px) {
      input, select, textarea {
        font-size: 16px !important;
      }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>
      <div style={styles.container} className="mobile-money-container">
        <div style={styles.containerBefore} />
        
        <h2 style={styles.title} className="mobile-money-title">
          💳 Paiement Mobile Money 
        </h2>

        <div style={styles.infoBox} className="mobile-money-info">
          <p style={styles.infoText}>
            Pour confirmer votre réservation du vehicule <strong style={styles.highlight}>:{marque} {modele} </strong>, <br />
            vous devez envoyer <strong style={styles.highlight}>{prix} $</strong> à l'un des numéros ci-dessous :
          </p>
          
          <div style={styles.networkList} className="network-list">
            {networks.map((net, index) => (
              <div
                key={index}
                style={{
                  ...styles.networkItem,
                  ...(hoveredNetwork === index && styles.networkItemHover)
                }}
                className="network-item"
                onMouseEnter={() => setHoveredNetwork(index)}
                onMouseLeave={() => setHoveredNetwork(null)}
              >
                <span style={styles.networkIcon}><img src={net.icon} style={{width:'50px'}} alt="" /></span>
                <span style={styles.networkName}>{net.name}</span>
                <span style={styles.networkNumber}>{net.number}</span>
              </div>
            ))}
          </div>

          <p style={{...styles.infoText, marginTop: "1.5rem"}}>
            Ensuite, renseignez le réseau utilisé, le numéro avec lequel vous avez envoyé l'argent 
            et votre code de réservation. <br />
            Un email de confirmation et une facturation vous sera envoyé apres verification de votre paiement. <br />
            Contactez-nous sur le : +243 900 800 035

          </p>
        </div>

        {message && (
          <div style={{
            ...styles.message,
            ...(message.type === "success" ? styles.successMessage : styles.errorMessage)
          }}>
            {message.type === "success" ? "✅" : "❌"} {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formRow}>
            {/* Choix du réseau */}
            <div style={styles.formGroup}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>📶</span>
                Réseau utilisé
              </label>
              <select
                value={network}
                onChange={(e) => setNetwork(e.target.value)}
                onFocus={handleFocus('network')}
                onBlur={handleBlur}
                style={{
                  ...styles.input,
                  ...styles.select,
                  ...(focusedField === 'network' && styles.inputFocus)
                }}
                className="mobile-money-input"
              >
                <option value="">-- Sélectionnez un réseau --</option>
                <option value="Orange Money">Orange Money</option>
                <option value="Airtel Money">Airtel Money</option>
                <option value="Mpsa">MPSA</option>
              </select>
            </div>

            {/* Numéro expéditeur */}
            <div style={styles.formGroup}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>📞</span>
                Votre Numéro utilisé lors du paiement
              </label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                onFocus={handleFocus('phone')}
                onBlur={handleBlur}
                style={{
                  ...styles.input,
                  ...(focusedField === 'phone' && styles.inputFocus)
                }}
                className="mobile-money-input"
                placeholder="Ex: +243 89 000 0000"
              />
            </div>
          </div>

          {/* Code de réservation */}
          <div style={styles.formGroup}>
            <label style={styles.label}>
              <span style={styles.labelIcon}>🔐</span>
              Code de réservation
            </label>
            <input
              type="text"
              value={reservationCode}
              onChange={(e) => setReservationCode(e.target.value)}
              onFocus={handleFocus('reservationCode')}
              onBlur={handleBlur}
              style={{
                ...styles.input,
                ...(focusedField === 'reservationCode' && styles.inputFocus)
              }}
              className="mobile-money-input"
              placeholder="Ex: 2345644"
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            style={{
              ...styles.button,
              ...(isButtonHovered && !isLoading && styles.buttonHover),
              ...(isLoading && styles.buttonDisabled),
            }}
            className="mobile-money-button"
            onMouseEnter={() => setIsButtonHovered(true)}
            onMouseLeave={() => setIsButtonHovered(false)}
          >
            {isLoading ? (
              <>
                <div style={styles.spinner} />
                Traitement en cours...
              </>
            ) : (
              <>
                🚀 Confirmer le paiement
              </>
            )}
          </button>
        </form>
      </div>
    </>
  );
};

export default MobileMoneyForm;